export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const localePath = useLocalePath()
  const { user, refresh } = useAuthUser()

  if (!user.value) {
    await refresh()
  }

  if (!user.value) {
    return navigateTo(localePath('/login'))
  }
})
